import Reveal from '@/components/base/Reveal';
import { BrandMark } from '@/components/feature/BrandLogo';
import { brandSupports, type SupportKind } from '@/mocks/brand';

const PHOTO_WORKSITE =
  'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.04.28.jpeg';

function SupportPreview({ kind }: { kind: SupportKind }) {
  if (kind === 'letterhead') {
    return (
      <div className="relative h-[176px] w-[126px] overflow-hidden rounded-sm bg-background-50">
        <div className="flex h-8 items-center bg-primary-500 px-2">
          <span className="rounded-sm bg-background-50 px-1 py-0.5">
            <BrandMark size={14} />
          </span>
        </div>
        <div className="mt-1 h-0.5 w-full bg-accent-500" />
        <div className="space-y-1.5 p-2 pt-3">
          <span className="block h-[2px] w-full bg-foreground-200" />
          <span className="block h-[2px] w-11/12 bg-foreground-200" />
          <span className="block h-[2px] w-4/5 bg-foreground-200" />
          <span className="block h-[2px] w-10/12 bg-foreground-200" />
          <span className="block h-[2px] w-2/3 bg-foreground-200" />
        </div>
        <div className="absolute inset-x-0 bottom-0 border-t border-secondary-400 px-2 py-1.5">
          <span className="block h-[2px] w-2/3 bg-secondary-400" />
          <span className="mt-1 block h-[2px] w-1/2 bg-secondary-300" />
        </div>
      </div>
    );
  }

  if (kind === 'business-card') {
    return (
      <div className="space-y-2">
        <div className="flex h-[74px] w-[142px] items-center justify-center rounded-sm bg-primary-500">
          <span className="rounded-sm bg-background-50 px-1.5 py-1">
            <BrandMark size={16} />
          </span>
        </div>
        <div className="h-[74px] w-[142px] rounded-sm border border-background-300 bg-background-50 p-2.5">
          <span className="block h-[3px] w-2/3 bg-foreground-900" />
          <span className="mt-1 block h-[2px] w-1/2 bg-secondary-400" />
          <span className="mt-2 block h-0.5 w-8 bg-accent-500" />
          <span className="mt-2 block h-[2px] w-3/4 bg-foreground-200" />
          <span className="mt-1 block h-[2px] w-2/3 bg-foreground-200" />
        </div>
      </div>
    );
  }

  if (kind === 'quote') {
    return (
      <div className="h-[176px] w-[136px] overflow-hidden rounded-sm bg-background-50 p-2.5">
        <div className="flex items-center justify-between">
          <span className="rounded-sm bg-background-50">
            <BrandMark size={14} />
          </span>
          <span className="font-heading text-[7px] font-semibold uppercase tracking-wide text-primary-600">
            Devis
          </span>
        </div>
        <div className="mt-2 h-[2px] w-full bg-primary-500" />
        <div className="mt-2 space-y-1">
          <span className="block h-[2px] w-1/3 bg-foreground-300" />
          <span className="block h-[2px] w-1/2 bg-foreground-200" />
        </div>
        <div className="mt-2 space-y-1.5">
          <span className="block h-[6px] w-full bg-background-100" />
          <span className="block h-[6px] w-full bg-background-100" />
          <span className="block h-[6px] w-full bg-background-100" />
          <span className="block h-[6px] w-4/5 bg-background-100" />
        </div>
        <div className="mt-2 flex items-center justify-between rounded-sm bg-accent-500 px-1.5 py-1">
          <span className="text-[6px] font-semibold uppercase tracking-wide text-foreground-950">
            Total
          </span>
          <span className="text-[6px] font-bold text-foreground-950">CFA</span>
        </div>
      </div>
    );
  }

  if (kind === 'signature') {
    return (
      <div className="w-[176px] rounded-sm border border-background-300 bg-background-50 p-2.5">
        <div className="flex items-start gap-2">
          <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-sm bg-primary-500 font-heading text-[11px] font-semibold text-background-50">
            SG
          </span>
          <div className="min-w-0 flex-1">
            <span className="block h-[3px] w-2/3 bg-foreground-900" />
            <span className="mt-1 block h-[2px] w-1/2 bg-secondary-400" />
            <span className="mt-1.5 block h-0.5 w-full bg-accent-500" />
            <span className="mt-1.5 block h-[2px] w-11/12 bg-foreground-200" />
            <span className="mt-1 block h-[2px] w-3/4 bg-foreground-200" />
            <span className="mt-1 block h-[2px] w-2/3 bg-primary-300" />
          </div>
        </div>
      </div>
    );
  }

  if (kind === 'workwear') {
    return (
      <div className="relative">
        <div className="relative h-[124px] w-[92px] rounded-t-2xl bg-primary-500">
          <span className="absolute inset-x-0 top-0 mx-auto h-6 w-9 rounded-b-full bg-background-100" />
          <span className="absolute inset-x-0 top-6 mx-auto h-[2px] w-9 bg-primary-900" />
          <span className="absolute bottom-8 left-0 h-2 w-full bg-accent-500" />
          <span className="absolute bottom-4 left-0 h-1 w-full bg-secondary-300" />
          <span className="absolute right-2 top-8 rounded-sm bg-background-50 px-1 py-0.5">
            <BrandMark size={12} />
          </span>
        </div>
        <p className="mt-2 text-center font-label text-[7px] uppercase tracking-[0.14em] text-foreground-400">
          Dos : logo 22 cm
        </p>
      </div>
    );
  }

  if (kind === 'helmet') {
    return (
      <div className="flex flex-col items-center">
        <div className="relative h-[62px] w-[104px] overflow-hidden rounded-t-[52px] border border-secondary-300 bg-background-50">
          <span className="absolute left-1/2 top-7 -translate-x-1/2 rounded-sm bg-background-50 px-1">
            <BrandMark size={16} />
          </span>
          <span className="absolute inset-x-6 top-0 h-[3px] bg-secondary-200" />
        </div>
        <div className="-mt-1 h-[7px] w-[124px] rounded-full bg-accent-500" />
        <p className="mt-2 font-label text-[7px] uppercase tracking-[0.14em] text-foreground-400">
          Encadrement : blanc · Équipes : orange
        </p>
      </div>
    );
  }

  if (kind === 'vehicle') {
    return (
      <div className="relative h-[96px] w-[176px]">
        <div className="absolute bottom-5 left-0 right-4 h-[44px] rounded-t-md border border-background-300 bg-background-50">
          <span className="absolute inset-x-0 bottom-0 h-2.5 bg-primary-500" />
          <span className="absolute bottom-2.5 left-0 h-1 w-full bg-accent-500" />
          <span className="absolute left-3 top-3 rounded-sm">
            <BrandMark size={20} />
          </span>
          <span className="absolute bottom-3.5 right-2 h-[2px] w-8 bg-secondary-400" />
          <span className="absolute inset-y-2 right-0 w-8 rounded-r-md border border-background-300 bg-background-100" />
        </div>
        <span className="absolute bottom-1 left-6 h-6 w-6 rounded-full border-[3px] border-foreground-800 bg-secondary-500" />
        <span className="absolute bottom-1 right-8 h-6 w-6 rounded-full border-[3px] border-foreground-800 bg-secondary-500" />
      </div>
    );
  }

  if (kind === 'site-sign') {
    return (
      <div className="flex flex-col items-center">
        <div className="w-[150px] overflow-hidden rounded-sm border-2 border-accent-500 bg-primary-500 p-2">
          <span className="inline-block rounded-sm bg-background-50 px-1 py-0.5">
            <BrandMark size={16} />
          </span>
          <span className="mt-2 block h-[3px] w-4/5 bg-background-50" />
          <span className="mt-1 block h-[2px] w-2/3 bg-background-200" />
          <span className="mt-2 block h-[2px] w-full bg-background-50/40" />
          <span className="mt-1 block h-[2px] w-5/6 bg-background-50/40" />
        </div>
        <div className="flex w-[150px] justify-between px-3">
          <span className="h-6 w-1.5 bg-secondary-500" />
          <span className="h-6 w-1.5 bg-secondary-500" />
        </div>
      </div>
    );
  }

  if (kind === 'document-cover') {
    return (
      <div className="relative h-[172px] w-[124px] overflow-hidden rounded-sm bg-primary-950">
        <div className="absolute inset-0 blueprint-grid opacity-40" />
        <div className="relative flex h-full flex-col justify-between p-3">
          <span className="inline-flex w-fit rounded-sm bg-background-50 px-1 py-0.5">
            <BrandMark size={14} />
          </span>
          <div>
            <span className="block h-0.5 w-8 bg-accent-500" />
            <span className="mt-2 block h-[3px] w-full bg-background-50" />
            <span className="mt-1 block h-[3px] w-3/4 bg-background-50" />
            <span className="mt-2 block h-[2px] w-1/2 bg-background-300" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-[142px] overflow-hidden rounded-sm border border-background-300 bg-background-50">
      <div className="relative h-[92px] w-full overflow-hidden bg-foreground-950">
        <img
          src={PHOTO_WORKSITE}
          alt="Publication SGSCTIC — chantier industriel"
          className="h-full w-full object-cover object-top"
        />
        <span className="absolute right-2 top-2 h-4 w-4 rounded-sm bg-accent-500" />
      </div>
      <div className="space-y-1.5 bg-primary-950 p-2">
        <span className="block h-[3px] w-4/5 bg-background-50" />
        <span className="block h-[2px] w-3/5 bg-background-300" />
      </div>
    </div>
  );
}

export default function BrandSupports() {
  return (
    <section id="supports" className="scroll-mt-32 border-t border-background-200 bg-background-50 py-16 md:py-24">
      <div className="container-wide">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <div className="max-w-2xl">
              <div className="flex items-center gap-3">
                <span className="h-px w-8 bg-accent-500" />
                <span className="label-mono text-primary-600">05 — Les supports</span>
              </div>
              <h2 className="display-title mt-5 text-4xl text-foreground-950 md:text-5xl">
                La marque hors du site
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
                Dix déclinaisons professionnelles, construites avec le logo officiel, le marine,
                l’orange et le gris métallique. Chaque support suit les mêmes règles de marges, de
                filets et de typographie.
              </p>
            </div>
            <div className="flex flex-none items-center gap-3 rounded-md border border-background-200 bg-background-100 px-4 py-3">
              <i className="ri-printer-line text-primary-600" />
              <span className="text-xs leading-snug text-foreground-600">
                Fichiers sources à préparer
                <br />
                <span className="text-foreground-400">CMJN · 300 dpi · fonds perdus 3 mm</span>
              </span>
            </div>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {brandSupports.map((support, index) => (
            <Reveal key={support.kind} delay={(index % 3) * 80}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300">
                <div className="relative flex h-[212px] items-center justify-center overflow-hidden bg-secondary-100">
                  <div className="absolute inset-0 blueprint-grid opacity-40" />
                  <div className="relative transition-transform duration-500 group-hover:-translate-y-1">
                    <SupportPreview kind={support.kind} />
                  </div>
                  <span className="absolute left-3 top-3 rounded-sm bg-background-50/90 px-2 py-1 font-label text-[9px] font-semibold uppercase tracking-[0.14em] text-primary-700">
                    {support.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col border-t border-background-200 p-5">
                  <h3 className="font-heading text-lg font-semibold uppercase leading-tight text-foreground-950">
                    {support.title}
                  </h3>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600">{support.text}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}